// @flow
import React from 'react';
import { FRONT_END_DISPLAY_NAMES } from '@streaming-projects/enums';
import { SPStreamGovernanceWorkloadEnabledContainer } from '@streaming-projects/workloads/stream-governance-workloads/enable/SPStreamGovernanceWorkloadEnabledContainer';

export const SPStreamGovernanceWorkloadEnabledCellRenderer = (props) => {
  if (props.value == null) {
    return null;
  }

  const streamGovernanceWorkloadId = props.data[FRONT_END_DISPLAY_NAMES.WORKLOAD_ID];
  const streamGovernanceResourceId = props.data[FRONT_END_DISPLAY_NAMES.RESOURCE_ID];

  return (
    <SPStreamGovernanceWorkloadEnabledContainer
      addLabel={false}
      checked={props.value}
      streamGovernanceResourceId={streamGovernanceResourceId}
      streamGovernanceWorkloadId={streamGovernanceWorkloadId}
    />
  );
};
